import { useCheckoutStore } from '@entities/order'
import { useCheckoutOrderApi } from '@entities/order'
import { useCommonStore } from '@shared/model'
import { trackEvent } from '@shared/lib/amplitude'
import { show404 } from '@shared/lib/page-error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( async (to) => {
  const order = to.params?.order as string | undefined
  const notifyType = (to.query.notify_type || null) as string | null
  const solidOrderId: string | null = (to?.query?.solid_order_id || null) as string | null
  const paymentIntentId: string | null = (to?.query?.payment_intent || null) as string | null

  const validOrder: boolean = typeof order === 'string'

  if (!validOrder) return show404()

  const commonStore = useCommonStore()
  const checkoutStore = useCheckoutStore()

  const orderId = Number(order)
  const validOrderId = isFinite(orderId)

  if (!validOrderId) return show404()

  checkoutStore.setNotifyType(notifyType)

  void useCheckoutOrderApi({ orderId, solidOrderId, paymentIntentId, mode: 'enter' }, {
    onStart: () => {
      commonStore.setLoading(true)
    },
    onSuccess: () => {
      // Shared by the order page and its upsell page; each reports as its own page.
      const isUpsell = to.path.endsWith('/upsell')

      trackEvent('Page_view', {
        ...checkoutStore.getEventProps,
        feature: isUpsell ? 'upsell' : 'checkout',
        name: isUpsell ? 'upsell' : 'order',
      })
    },
    onFinish: () => {
      commonStore.setLoading(false)
    },
  })
})
